import { Heading, Page } from '@zillow/constellation-10';

import UnsubscribeError from 'app/shared/components/UnsubscribeError';

type UnsubscribeAllViewProps = { didUnsubscribeAllSucceed: boolean };

const UnsubscribeAllView = ({ didUnsubscribeAllSucceed }: UnsubscribeAllViewProps) => {
  return (
    <Page.Root
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'bg.screen.neutral',
      }}
    >
      <Page.Content css={{ paddingBottom: '1500' }}>
        {didUnsubscribeAllSucceed ? (
          <>
            <Heading level={1} textStyle="heading-lg" fontFamily="heading-alt" css={{ marginTop: '800' }}>
              Thank you!
            </Heading>
            <Heading level={2} textStyle="body-lg-bold" css={{ marginTop: '600' }}>
              You’ve been unsubscribed from all market update emails
            </Heading>
          </>
        ) : (
          <UnsubscribeError />
        )}
      </Page.Content>
    </Page.Root>
  );
};

export default UnsubscribeAllView;
